import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { useActivityDetailsStore } from '@apps/main/new-desktop/core/stores';

import type { Distance } from '../models';

import {
  getButtonText,
  getDistances,
  getFacilities,
  getMainDescription,
  getTagsUrls,
  getOpeningParagraph,
} from './activityDetailsDescriptionStoreLogic';

const DEFAULT_SHOW_FULL_DESCRIPTION = false;

export const useActivityDetailsDescriptionStore = defineStore(
  'ActivityDetailsDescriptionStore',
  () => {
    const activityDetailsStore = useActivityDetailsStore();

    // State
    const showFullDescription = ref<boolean>(DEFAULT_SHOW_FULL_DESCRIPTION);

    // Actions
    function toggleFullDescription(): void {
      showFullDescription.value = !showFullDescription.value;
    }
    // Getters

    const buttonText = computed<string>(() =>
      getButtonText(showFullDescription.value)
    );

    const distances = computed<Distance[] | undefined>(() =>
      getDistances(activityDetailsStore.activityDetailsStaticData)
    );

    const facilities = computed<string[] | undefined>(() =>
      getFacilities(activityDetailsStore.activityDetailsStaticData)
    );

    const mainDescription = computed<string | undefined>(() =>
      getMainDescription(
        activityDetailsStore.activityDetailsStaticData,
        showFullDescription.value,
        tagsUrls.value,
        {
          tagsEquivalent: 40,
          toFillSpaceNextToMap: 700,
        }
      )
    );

    const openingParagraph = computed<string | undefined>(() =>
      getOpeningParagraph(activityDetailsStore.activityDetailsStaticData)
    );

    const tagsUrls = computed<string[] | undefined>(() =>
      getTagsUrls(activityDetailsStore.activityDetailsStaticData)
    );

    return {
      // Getters
      buttonText,
      distances,
      facilities,
      mainDescription,
      openingParagraph,
      tagsUrls,

      // Actions
      toggleFullDescription,
    };
  }
);
